// extracted by mini-css-extract-plugin
export var aboutPageIntro = "About-module--aboutPageIntro--wIonZ";
export var aboutGallery = "About-module--aboutGallery--JInSn";